import { render, staticRenderFns } from "./ShopLandingPage.vue?vue&type=template&id=2800ddb8&"
import script from "./ShopLandingPage.vue?vue&type=script&lang=js&"
export * from "./ShopLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./ShopLandingPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports